import React from "react";

import { ChartEmptyState } from "../../../../components/States";
import { EmptyLiabilitiesStateProps } from "./types";

// Stroke inherits white from the illustration's front card via currentColor.
const debtChart = (
  <svg
    width="60"
    height="34"
    viewBox="0 0 60 34"
    fill="none"
    aria-hidden="true"
  >
    <polyline
      points="3,7 17,13 30,10 44,21 57,27"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.95"
    />
    <circle cx="57" cy="27" r="3" fill="currentColor" />
  </svg>
);

const FIRST_RUN_DESCRIPTION =
  "Track loans, mortgages and credit in one place. Add a liability and its balance, payoff progress and cost of borrowing appear here automatically.";
const FILTERED_DESCRIPTION =
  "No liabilities match the current filters. Adjust the filters or add a new liability to see it here.";

export const EmptyLiabilitiesState: React.FC<EmptyLiabilitiesStateProps> = ({
  onCreateLiability,
  isFiltered,
  onClearFilters,
}) => {
  const title = isFiltered
    ? "No liabilities found"
    : "Add your first liability";
  const description = isFiltered ? FILTERED_DESCRIPTION : FIRST_RUN_DESCRIPTION;
  const showClearFilters = isFiltered && Boolean(onClearFilters);

  return (
    <ChartEmptyState
      chart={debtChart}
      title={title}
      description={description}
      buttonLabel="Add liability"
      onAction={onCreateLiability}
      ariaLabel="No liabilities yet"
      secondaryActionLabel={showClearFilters ? "Clear filters" : undefined}
      onSecondaryAction={showClearFilters ? onClearFilters : undefined}
    />
  );
};
